module.exports = __webpack_public_path__ + "static/media/like.0cf55cd0.svg";